/* NAKED US : fiche produit (choix des tailles, prix dans le bouton, ajout au panier, barre collante).
   Écrit pour Horizon, sans code Impact. Évènements émis pour les scripts NAKED :
   - 'variant:change' sur le formulaire (bulle) et 'nk:variant-change' sur document : detail { variant, product }
   - 'variant:add' et 'cart:refresh' sur document après un ajout réussi : detail { items, variant, cart? } */
(function () {
  'use strict';
  var root = document.querySelector('[data-nk-buy]');
  if (!root || root.__nk) return;
  root.__nk = true;

  var form = root.querySelector('[data-nk-form]');
  var idInput = form.querySelector('[data-nk-variant-id]');
  var atc = form.querySelector('[data-nk-atc]');
  var errBox = form.querySelector('[data-nk-error]');
  var sticky = document.querySelector('[data-nk-sticky]');
  var stickyBtn = sticky && sticky.querySelector('[data-nk-sticky-btn]');
  /* la barre flottante quitte la section produit : sinon les rails suivants passent au-dessus */
  if (sticky && sticky.parentElement !== document.body) document.body.appendChild(sticky);
  var product = null, moneyFormat = '${{amount}}';
  try { product = JSON.parse(document.querySelector('[data-nk-product-json]').textContent); } catch (e) { return; }
  try { moneyFormat = JSON.parse(document.querySelector('[data-nk-money-format]').textContent) || moneyFormat; } catch (e) {}

  /* 25/10/2026 (marchés AU, NZ, IT, SE, DK, NO, FI, PL) : tous les gabarits de prix Shopify. Le format arrive dans la devise du
     marché (SEK : « {{amount_with_space_separator}} kr », affiché tel quel avant ce correctif). Dollar US inchangé : « $1,234.56 ». */
  function money(cents) {
    function fmt(dec, ths, dsep) {
      var n = (Math.round(cents) / 100).toFixed(dec);
      var parts = n.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ths);
      return dec ? parts[0] + dsep + parts[1] : parts[0];
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_with_period_and_space_separator': return fmt(2, ' ', '.');
        default: return fmt(2, ',', '.');
      }
    });
  }
  /* Libellés dans la langue de la page (data-nk-pdp-texts, posé par nk-pdp-form) ; repli anglais = textes US d'origine. */
  var T = { select: 'Select size', add: 'Add to cart', soldout: 'Sold out', network: 'Network error, please try again.', notadded: 'This item could not be added.' };
  try { var tx = JSON.parse(document.querySelector('[data-nk-pdp-texts]').textContent); for (var tk in tx) if (tx[tk]) T[tk] = tx[tk]; } catch (e) {}

  var sets = [].slice.call(form.querySelectorAll('fieldset.nk-opt'));
  var pickerEl = form.querySelector('[data-nk-picker]'); if (pickerEl) pickerEl.product = product; // contrat du calculateur de taille (nkd-taille.js)
  function selected() {
    return sets.map(function (fs) { var r = fs.querySelector('input[type="radio"]:checked'); return r ? r.value : null; });
  }
  function findVariant(values) {
    if (product.variants.length === 1 && !sets.length) return product.variants[0];
    if (values.some(function (v) { return v === null; })) return null;
    return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); }) || null;
  }
  var current = idInput.value ? product.variants.find(function (v) { return String(v.id) === idInput.value; }) : null;

  function paintAvailability(values) {
    sets.forEach(function (fs, i) {
      [].forEach.call(fs.querySelectorAll('input[type="radio"]'), function (r) {
        var trial = values.slice(); trial[i] = r.value;
        var ok = product.variants.some(function (v) {
          return v.available && v.options.every(function (o, k) { return trial[k] === null || trial[k] === o || k === i && o === r.value; }) && v.options[i] === r.value;
        });
        var lab = form.querySelector('label[for="' + r.id + '"]');
        if (lab) lab.classList.toggle('is-unavailable', !ok);
      });
    });
  }

  function paintButtons(v) {
    var ready = !!v;
    var label = !ready ? T.select : (v.available ? T.add : T.soldout);
    [atc, stickyBtn].forEach(function (b) {
      if (!b) return;
      b.classList.toggle('is-ready', ready);
      b.querySelector('.nk-atc__label').textContent = label;
      var pr = b.querySelector('.nk-atc__prices');
      if (pr) {
        pr.hidden = !ready;
        if (ready) {
          var was = v.compare_at_price && v.compare_at_price > v.price ? '<s class="nk-atc__was">' + money(v.compare_at_price) + '</s>' : '';
          pr.innerHTML = '<span class="nk-atc__sep" aria-hidden="true">–</span><span class="nk-atc__now">' + money(v.price) + '</span>' + was;
        }
      }
      b.disabled = ready && !v.available;
    });
    // prix en tête de fiche (bloc NAKED .price-info)
    if (v) {
      var cp = document.querySelector('.price-info .current-price'); if (cp) cp.textContent = money(v.price);
      var op = document.querySelector('.price-info .old-price'); if (op && v.compare_at_price > v.price) op.textContent = money(v.compare_at_price);
    }
  }

  function update(source) {
    var values = selected();
    sets.forEach(function (fs, i) {
      var val = fs.querySelector('.nk-opt__value'); if (val) val.textContent = values[i] || '';
      [].forEach.call(fs.querySelectorAll('.nk-swatch'), function (l) { l.classList.toggle('is-selected', l.getAttribute('data-value') === values[i]); });
      if (values[i]) fs.classList.remove('nk-opt--need');
    });
    paintAvailability(values);
    var v = findVariant(values);
    var prev = current; current = v;
    idInput.value = v ? v.id : '';
    paintButtons(v);
    if (v && (!prev || prev.id !== v.id)) {
      if (source !== 'init') {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
      var detail = { variant: v, previousVariant: prev, product: product };
      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: detail }));
      document.dispatchEvent(new CustomEvent('nk:variant-change', { detail: detail }));
    }
  }
  form.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') update('user'); });
  // les scripts NAKED (mémoire de taille, calculateur) cochent parfois une case par .checked = true + évènement
  document.addEventListener('nk:refresh-variant', function () { update('script'); });

  function needSize() {
    var first = sets.find(function (fs) { return !fs.querySelector('input[type="radio"]:checked'); });
    if (!first) return false;
    sets.forEach(function (fs) { if (!fs.querySelector('input[type="radio"]:checked')) fs.classList.add('nk-opt--need'); });
    first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errBox.hidden = true;
    if (!current) { needSize(); return; }
    if (!current.available) return;
    atc.classList.add('is-loading'); atc.disabled = true;
    var body = new FormData(form);
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { errBox.textContent = res.j.description || res.j.message || T.notadded; errBox.hidden = false; return; }
        var items = res.j.items || [res.j];
        document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, variant: current, product: product } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        document.dispatchEvent(new CustomEvent('nk:cart-add', { detail: { items: items } }));
      })
      .catch(function () { errBox.textContent = T.network; errBox.hidden = false; })
      .finally(function () { atc.classList.remove('is-loading'); atc.disabled = !!(current && !current.available); });
  });

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (!current) { needSize(); return; }
      if (form.requestSubmit) form.requestSubmit(); else atc.click();
    });
    if ('IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 749px)');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // mobile : barre toujours présente (comme la fiche FR) ; bureau : dès que le bouton principal sort de l'écran
        var show = mq.matches || (!e.isIntersecting && e.boundingClientRect.top < 0);
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
  }

  update('init');
})();

/* Galerie mobile NAKED : flèches, loupe, taille du mannequin, barre de progression, posées sur le diaporama d'Horizon. */
(function () {
  'use strict';
  function init() {
    var g = document.querySelector('.nk-pdp media-gallery slideshow-component');
    if (!g || g.__nkGal) return; g.__nkGal = true;
    var track = g.querySelector('slideshow-slides'); if (!track) return;
    var cont = g.querySelector('slideshow-container') || g; cont.style.position = 'relative';
    var ui = document.createElement('div'); ui.className = 'nk-gal-ui';
    var chev = function (d) { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>'; };
    ui.innerHTML = '<button type="button" class="nk-gal-arrow nk-gal-arrow--prev" aria-label="Previous image">' + chev(-1) + '</button>' +
      '<button type="button" class="nk-gal-arrow nk-gal-arrow--next" aria-label="Next image">' + chev(1) + '</button>' +
      '<button type="button" class="nk-gal-zoom" aria-label="Zoom"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M11 8v6M8 11h6M20 20l-4-4"/></svg></button>';
    var model = document.querySelector('[data-nk-model-size]');
    if (model && model.textContent.trim()) { var b = document.createElement('span'); b.className = 'nk-gal-model'; b.textContent = model.textContent.trim(); ui.appendChild(b); }
    cont.appendChild(ui);
    var bar = document.createElement('div'); bar.className = 'nk-gal-progress'; bar.innerHTML = '<i></i>'; g.appendChild(bar);
    var slides = track.querySelectorAll('slideshow-slide');
    function step(dir) { var w = slides[0] ? slides[0].getBoundingClientRect().width + 2 : track.clientWidth; track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
    ui.querySelector('.nk-gal-arrow--prev').addEventListener('click', function () { step(-1); });
    ui.querySelector('.nk-gal-arrow--next').addEventListener('click', function () { step(1); });
    ui.querySelector('.nk-gal-zoom').addEventListener('click', function () {
      var w = slides[0] ? slides[0].getBoundingClientRect().width + 2 : 1; var i = Math.round(track.scrollLeft / w);
      var s = slides[i] || slides[0]; var z = s && (s.querySelector('img') || s); if (z) z.click();
    });
    var fill = bar.querySelector('i');
    function prog() { var max = track.scrollWidth - track.clientWidth; var p = max > 0 ? track.scrollLeft / max : 0; var w = Math.max(18, 100 * track.clientWidth / track.scrollWidth); fill.style.width = w + '%'; fill.style.transform = 'translateX(' + (p * (100 / w - 1) * 100) + '%)'; }
    track.addEventListener('scroll', prog, { passive: true }); prog();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Blocs NAKED vides (aucune donnée pour ce produit) : retirés du rythme vertical de la fiche. */
(function () {
  function sweep() {
    var info = document.querySelector('.nk-pdp-info'); if (!info) return;
    info.querySelectorAll('.nk-pdp-info > div > div, .nk-pdp-info .group-block-content > *').forEach(function (el) {
      if (el.closest('.nk-sticky')) return;
      var r = el.getBoundingClientRect(); el.classList.toggle('nk-vide', r.height < 1 && !el.querySelector('dialog, [data-nk-sticky]'));
    });
  }
  window.addEventListener('load', function () { sweep(); setTimeout(sweep, 1500); });
})();
